import { useSelector } from 'react-redux';

import { isSelfModerator } from '../../../../pages/call/selectors';
import { SELF } from '../../../constants';
import { isDefined } from '../../../helpers/isDefined';
import { useModerationPermissionsExtended } from './use-moderation-permissions-extended';

const useShouldShowModerationControls = (id: string, isMobile?: boolean) => {
    const selfModerator = useSelector(isSelfModerator);
    const isAnonymousUser = useSelector((state) => !state.user);
    const { isPermissionsExtendedEnabled, hasMicrophoneMutePermission, hasAnyModerationPermissionWithoutMicrophone } =
        useModerationPermissionsExtended();
    const isSelf = id === SELF;
    const isTouch = isDefined(isMobile) && isMobile;
    const shouldShowModerationPopupButton =
        !isTouch &&
        (selfModerator ||
            (isSelf && !isAnonymousUser) ||
            (isPermissionsExtendedEnabled && hasAnyModerationPermissionWithoutMicrophone));
    const shouldShowModerationMicrophone =
        !isTouch && (selfModerator || isSelf || (isPermissionsExtendedEnabled && hasMicrophoneMutePermission));
    return {
        shouldShowModerationPopupButton,
        shouldShowModerationMicrophone,
    };
};

export default useShouldShowModerationControls;
